const FancyColor = [
    "BLUE",
    "BROWN",
    "BROWN PINK",
    "BROWN YELLOW",
    "DARK GRAY",
    "GRAY",
    "GREEN",
    "GREEN GRAY",
    "GREEN YELLOW",
    "GREY",
    "LIGHT BROWNISH YELLOW",
    "ORANGE",
    "ORANGE BROWN",
    "ORANGE YELLOW",
    "ORANGY BROWN",
    "ORANGY RED",
    "ORANGY YELLOW",
    "PINK",
    "PINK BROWN",
    "PINKISH",
    "PINKISH ORANGE",
    "PURPLE",
    "RED",
    "YELLOW",
    "YELLOW  GREEN",
    "YELLOW BROWN",
    "YELLOW GREEN",
    "YELLOW ORANGE"
];

export default FancyColor;

